import { SyntheticEvent } from "react"
import {
  Block,
  ButtonProps,
  HeadingLarge,
  ParagraphLarge,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { IS_MEZO_MAINNET } from "#/shared/constants"
import {
  SanityCmsDataType,
  useSanityCmsData,
  useSinglePageRouterChange,
} from "#/shared/hooks"
import { buildUrlForSanityCmsImage, isExternalUrl } from "#/shared/utils"
import { InnerContainer } from "#/ui/Layout"
import DraggableContainer from "#/ui/Layout/Containers/DraggableContainer"

import MezoAppsItem from "./MezoAppsItem"

type ExploreSectionData = {
  exploreSection: {
    title: string
    description: string
    label: string
    labelColor: string
    url: string
    image: { asset: { _ref: string } }
    ctaText: string
    ctaAttr: string
    ctaIcon: { asset: { _ref: string } }
  }[]
  title: string
}

export default function MezoApps() {
  const { data: exploreData, error: exploreError } =
    useSanityCmsData<ExploreSectionData>(
      IS_MEZO_MAINNET
        ? SanityCmsDataType.Explore
        : SanityCmsDataType.ExploreTestnet,
    )

  const { changeRoute } = useSinglePageRouterChange()
  const [css, theme] = useStyletron()

  if (!exploreData || exploreError) return null

  const { exploreSection } = exploreData

  return (
    <InnerContainer
      position="relative"
      overrides={{ Block: { style: () => ({ zIndex: 2 }) } }}
    >
      <DraggableContainer
        header={
          <>
            <HeadingLarge>Apps on Mezo</HeadingLarge>
            <ParagraphLarge>Explore apps build on Mezo</ParagraphLarge>
          </>
        }
        marginBottom={theme.sizing.scale1200}
        hasControls
      >
        <Block
          className={css({
            display: "grid",
            gridTemplateColumns: `repeat(${Math.max(
              Math.ceil(exploreSection.length / 2),
              2,
            )}, minmax(400px, 1fr))`,
            gap: theme.sizing.scale600,
          })}
        >
          {exploreSection.map((item, index) => {
            const external = isExternalUrl(item.url)

            const buttonProps = external
              ? ({
                  $as: "a",
                  href: item.url,
                  target: "_blank",
                } as ButtonProps)
              : {
                  onClick: (e: SyntheticEvent<HTMLButtonElement>) => {
                    changeRoute(e, item.url)
                  },
                }

            return (
              <MezoAppsItem
                // eslint-disable-next-line react/no-array-index-key
                key={`${item.title}-${index}`}
                title={item.title}
                description={item.description}
                image={buildUrlForSanityCmsImage(item.image)}
                buttonProps={buttonProps}
                ctaText={item.ctaText}
                onClick={(e) => {
                  if (!isExternalUrl) {
                    changeRoute(e, item.url)
                  }
                }}
              />
            )
          })}
        </Block>
      </DraggableContainer>
    </InnerContainer>
  )
}
